import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'corner-down-left', 'IconCornerDownLeft', [["path",{"d":"M18 6v6a3 3 0 0 1 -3 3h-10l4 -4m0 8l-4 -4","key":"svg-0"}]]);